export default "__VITE_ASSET__D5x2bi8d__"